import DOMPurify from 'dompurify';

function cleanHtml(html?: string) {
    return DOMPurify.sanitize(html || '');
}

export { cleanHtml };
